<template>
    <div class="retailer-logos">
        <b-row>
            <b-col
                v-for="retailer in retailers"
                :key="retailer.name"
                cols="4"
                md="3"
            >
                <a
                    :href="retailer.link"
                    target="_blank"
                    rel="noopener"
                    v-test:link
                >
                    <span
                        class="sr-only"
                        v-test:a11yText
                    >
                        {{ $snippet('view_products_on', 'view products on') }} {{ retailer.name }}
                    </span>

                    <lazy-image
                        class="retailer-image"
                        :src="retailer.logo.src"
                        :alt="retailer.logo.alt"
                        :width="retailer.logo.width"
                        :height="retailer.logo.height"
                        v-test:retailerImage
                    />
                </a>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'retailer-logos',

        props: {
            retailers: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .row {
        align-items: center;
        justify-content: center;
        margin: 0 -10px;

        @include media-breakpoint-up(sm) {
            margin: 0 -20px;
        }

        > * {
            padding: 10px;

            @include media-breakpoint-up(sm) {
                padding: 20px;
            }
        }
    }

    .logo {
        padding: 20px;
        text-align: center;
    }

    .retailer-image {
        max-width: 100%;
        max-height: 64px;
        width: auto;
        height: auto;
    }

    a {
        filter: grayscale(100%);
        transition: 0.15s;
        display: block;

        &:hover,
        &:focus-visible,
        &:active {
            filter: grayscale(0);
        }
    }
</style>
